// ISO 3166-1 alpha-2 country codes to full country names
export const COUNTRY_NAMES = {
  AU: "Australia",
  NZ: "New Zealand",
  CN: "China",
  JP: "Japan",
  KR: "South Korea",
  SG: "Singapore",
  HK: "Hong Kong",
  MY: "Malaysia",
  PH: "Philippines",
  TH: "Thailand",
  ID: "Indonesia",
  VN: "Vietnam",
  TW: "Taiwan",
  IN: "India",
  PK: "Pakistan",
  BD: "Bangladesh",
  LK: "Sri Lanka",
  NP: "Nepal",
  KH: "Cambodia",
  LA: "Laos",
  MM: "Myanmar",
  MN: "Mongolia",
  MO: "Macau",
  BN: "Brunei",
  TL: "Timor-Leste",
  PG: "Papua New Guinea",
  FJ: "Fiji",
  SB: "Solomon Islands",
  VU: "Vanuatu",
  NC: "New Caledonia",
  PF: "French Polynesia",
  WS: "Samoa",
  TO: "Tonga",
  TV: "Tuvalu",
  KI: "Kiribati",
  US: "United States",
  CA: "Canada",
  GB: "United Kingdom",
  FR: "France",
  DE: "Germany",
  IT: "Italy",
  ES: "Spain",
  NL: "Netherlands",
  BE: "Belgium",
  AT: "Austria",
  CH: "Switzerland",
  DK: "Denmark",
  SE: "Sweden",
  NO: "Norway",
  FI: "Finland",
  IE: "Ireland",
  PT: "Portugal",
  GR: "Greece",
  PL: "Poland",
  CZ: "Czech Republic",
  HU: "Hungary",
  SK: "Slovakia",
  SI: "Slovenia",
  HR: "Croatia",
  RO: "Romania",
  BG: "Bulgaria",
  EE: "Estonia",
  LV: "Latvia",
  LT: "Lithuania",
  LU: "Luxembourg",
  LI: "Liechtenstein",
  MC: "Monaco",
  SM: "San Marino",
  VA: "Vatican City",
  IS: "Iceland",
  UA: "Ukraine",
  RU: "Russia",
  BY: "Belarus",
  MD: "Moldova",
  RS: "Serbia",
  ME: "Montenegro",
  MK: "North Macedonia",
  AL: "Albania",
  BA: "Bosnia and Herzegovina",
  // Add more as needed
};
